class TimeOperation {
    convertUtcToLocalDate(utcDateString) {
        // Create a new Date object from the UTC date string
        const utcDate = new Date(utcDateString);
        // Use toLocaleDateString to format the date in local time, including day, month, and year
        const localDateString = utcDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
        return localDateString;
    }
  }
  const timeOperation = new TimeOperation();
  export default timeOperation;